import { connect } from 'react-redux';

import {
  newSuccessNotification,
  newWarningNotification,
} from '../../components/common/redux/actions/notificationActions';

import component from './component';

export default connect(null, { newSuccess: newSuccessNotification, newWarning: newWarningNotification })(component);
